<script>
  import bootbox from '../../bootbox.min';

  export default {
    template: '#data-list',

    props: {
      dataSource: {
        type: String,
      },

      urlCreate: {
        type: String,
        default() {
          return null;
        },
      },

      labelCreate: {
        type: String,
        default() {
          return 'Cadastrar novo';
        },
      },

      deleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja apagar este registro?';
        },
      },

      resendMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja reenviar este e-mail?'
        },
      },

      undeleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja restaurar este usuário?'
        },
      },

      deleteTitle: {
        type: String,
        default() {
          return 'Excluir registro';
        },
      },

      resendTitle: {
        type: String,
        default() {
          return 'Reenviar e-mail';
        },
      },

      undeleteTitle: {
        type: String,
        default() {
          return 'Restaurar';
        },
      },
    },

    watch: {
      query: _.debounce(function (text) {
        this.currentPage = 1;
        this.fetchData();
      }, 350),

      'filters.status': function () {
        this.setFilter('status', this.filters.status);
        this.fetchData();
      },

      toggleAll(value) {
        this.selectedItems = (value)
          ? this.items.map((item) => item.id)
          : [];
      }
    },

    computed: {
      queryFilters() {
        let query_filters = '';
        for (var filterName in this.filters) {
          if (this.filters.hasOwnProperty(filterName)) {
            query_filters += '&' + filterName + '=' + this.filters[filterName];
          }
        }
        return query_filters;
      },

      fetch_url() {
        let query_params = '';
        query_params = '?query=' + this.query;
        query_params += '&field=' + this.field;
        query_params += '&order=' + this.order;
        if (this.currentPage != 1) {
          query_params += '&page=' + this.currentPage;
        }

        query_params += this.queryFilters;

        const url = this.dataSource + query_params;
        return encodeURI(url);
      },

      no_results() {
        return typeof this.items == 'undefined' || this.items.length == 0;
      },

      enabledNextPageButton() {
        return this.currentPage < this.totalPages;
      },

      enabledPrevPageButton() {
        return this.currentPage > 1;
      },

      shouldShowPagination() {
        return this.totalPages > 1;
      },

      isNotLoading() {
        return !this.loading;
      },
    },

    data() {
      return {
        items: [],
        totalItems: [],

        selectedItems: [],

        loading: true,

        query: '',
        field: '',
        order: 'desc',

        totalPages: 1,
        currentPage: 1,
        itemsPerPage: 15,
        paginationButtons: [],
        departmentId: null,
        departmentName: null,

        count: {
          actives: 0,
          inactives: 0,
        },

        filters: {},

        toggleAll: false,
      }
    },

    mounted() {
      this.listenFilters();
      this.listenLoadingEvents();
      this.fetchData();
      this.$root.$on('reload-data', () => this.fetchData());
    },

    methods: {
      getBadgeColorById(id) {
        let classes = ['dark', 'danger', 'warning', 'info', 'success', 'primary'];
        return classes[id % classes.length];
      },

      orderBy(field, event) {
        this.toggleOrder();
        this.field = field;
        this.setOrderArrowIn(event.target);
        this.fetchData();
      },

      orderByWithOrder(data) {
        this.order = data.order;
        this.field = data.value;
        this.fetchData();
      },

      toggleOrder() {
        this.order = (this.order === 'asc') ? 'desc' : 'asc';
        return this.order;
      },

      setOrderArrowIn(element) {
        let defaultClass = '.order-arrow';
        let classToRemove = $(element).attr('class');
        let toQuery = classToRemove ? `.${classToRemove} > .order-arrow` : defaultClass;

        let arrows = Array.from(document.querySelectorAll(toQuery));

        arrows.forEach((node) => {
          node.parentNode.removeChild(node);
        });

        element.appendChild(this.getArrow());
      },

      getArrow() {
        let arrow_classes = '';
        if (this.order == 'asc') {
          arrow_classes = 'fa fa-angle-up order-arrow'
        } else {
          arrow_classes = 'fa fa-angle-down order-arrow'
        }

        const arrow = document.createElement('i');
        arrow.className = arrow_classes;

        return arrow;
      },

      getRef(ref) {
        return this.$refs[ref];
      },

      setPagination(fetched_data) {
        if (typeof fetched_data !== 'undefined') {
          this.totalPages = fetched_data.last_page;
          this.totalItems = fetched_data.total;
          this.currentPage = fetched_data.current_page;
          this.itemsPerPage = fetched_data.per_page;
        }
      },

      fetchData() {
        const vm = this;
        this.$root.$emit('start-loading');
        const localQuery = this.query;
        axios.get(this.fetch_url).then((response) => {
          if (localQuery === this.query && response) {
            const responseData = response.data;
            if (responseData) {
              this.updateDataListing(responseData);
            }
          }

          this.$nextTick().then(function () {
            let div = $('[data-toggle="popover"]')
            if (div)
              div.popover();

            vm.$root.lazyImages();
          });
        });
      },

      updateDataListing(data) {
        this.items = data.data;
        this.setPagination(data.meta);
        this.definePaginationButtons();
        this.$root.$emit('stop-loading');
        this.$nextTick().then(function () {
          let div = $('[data-toggle="popover"]')
          if (div)
            div.popover();
        });
      },

      fetchPrevPage() {
        if (this.enabledPrevPageButton) {
          this.currentPage = this.currentPage - 1;
          this.fetchData();
        }
      },

      fetchNextPage() {
        if (this.enabledNextPageButton) {
          this.currentPage = this.currentPage + 1;
          this.fetchData();
        }
      },

      definePaginationButtons() {
        const totalPages = this.totalPages;
        let startPage = this.currentPage - 4;
        let endPage = this.currentPage + 4;
        let buttons = [];

        if (startPage <= 0) {
          endPage -= (startPage - 1);
          startPage = 1;
        }

        if (endPage > totalPages)
          endPage = totalPages;

        if (startPage > 1) {
          buttons.push({disabled: false, page: 1, text: '1'});
          buttons.push({disabled: true, page: 0, text: '...'});
        }

        for (let i = startPage; i <= endPage; i++) {
          const active = (i == this.currentPage);
          buttons.push({disabled: false, page: i, text: i, active: active});
        }

        if (endPage < totalPages) {
          buttons.push({disabled: true, page: 0, text: '...'});
          buttons.push({disabled: false, page: totalPages, text: totalPages});
        }

        this.paginationButtons = buttons;
      },

      changePage(page) {
        this.currentPage = page;
        this.fetchData();
      },

      handleDelete(link) {
        const token = $('meta[name="csrf-token"]').attr('content');
        const vm = this;
        $.ajax({
          url: link,
          type: 'DELETE',
          data: {_token: token},
          success: function (result) {
            result = JSON.parse(result);
            const type = result.type ? result.type : 'success';
            vm.$root.throwFlashMessage(type, result.message);
            vm.fetchData();
          }
        });
      },

      handleResendEmail(link) {
        axios.get(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      callAjax(link) {
        axios.post(link).then((response) => {
          this.$root.throwFlashMessage(response.data.type, response.data.message);
          this.fetchData();
        });
      },

      activate(link) {
        axios.post(link).then((response) => {
          this.$root.throwFlashMessage('success', "Registro habilitado com sucesso!");
          this.fetchData();
          this.fetchData();
        });
      },

      deactivate(link) {
        axios.post(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      confirmDelete(link, message = undefined) {
        if (message == undefined) {
          message = this.deleteMessage;
        }
        bootbox.confirm(message, result => {
          if (result) {
            this.handleDelete(link)
          }
        });
      },

      confirmResendEmail(link, message = undefined) {
        if (message == undefined) {
          message = this.resendMessage;
        }

        this.$snotify.confirm(message, this.resendTitle, {
          timeout: 5000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          buttons: [
            {text: 'Sim', action: () => this.handleResendEmail(link), bold: false},
            {text: 'Não'},
          ]
        });
      },

      confirmActivateDeactivate(link, action, message = undefined) {
        let title = 'Ativar';
        if (message == undefined) {
          if (action == 'activate') {
            message = 'Tem certeza que deseja habilitar esse registro?';
          } else {
            title = 'Desativar';
            message = 'Tem certeza que deseja desabilitar esse registro?';
          }
        }
        bootbox.confirm(message, result => {
          if (result) {
            this.activate(link)
          }
        });
      },

      callRef(ref, func, data) {
        this.$refs[ref][func](data);
      },

      listenFilters() {
        this.$on('setFilter', (payload) => {
          this.setFilter(payload.urlKey, payload.value);
          this.fetchData();
        });
      },

      setFilter(name, value) {
        if (value || value == 0) {
          this.$set(this.filters, name, value)
        } else {
          delete this.filters[name];
          this.filters = _.assign({}, this.filters);
        }
      },

      listenLoadingEvents() {
        this.$root.$on('start-loading', () => {
          this.loading = true;
        });

        this.$root.$on('stop-loading', () => {
          this.loading = false;
        });
      },

      allConfirm(route, message) {
        let vm = this;

        bootbox.confirm(message, function (result) {
          if (result) {
            let token = $('meta[name="csrf-token"]').attr('content');

            $.ajax({
              type: 'POST',
              url: route,
              data: {_token: token, _method: 'POST'},

              success: function (data, textStatus, xhr) {
                let message = JSON.parse(data);
                vm.$root.throwFlashMessage(message.type, message.message);

                let counter = $('#items_counter');
                counter.text(0);

                if (xhr.status != 202) {
                  vm.fetchData();
                }
              },
            });
          }
        });
      },

      multipleConfirm(route) {
        let message = $('.multiple-removal').data('message');
        let vm = this;

        if ($('input[data-removal]:checked').length != 0) {
          bootbox.confirm(message, function (result) {
            if (result) {
              let ids = [];
              $('input[data-removal]:checked').each(function () {
                ids.push($(this).val());
              });
              let token = $('meta[name="csrf-token"]').attr('content');

              let data = {
                items: ids,
              };

              $.ajax({
                type: 'POST',
                url: route,
                data: {_token: token, _method: 'POST', items: data},

                success: function (data, textStatus, xhr) {
                  let message = JSON.parse(data);
                  vm.$root.throwFlashMessage(message.type, message.message);

                  let counter = $('#items_counter');

                  vm.fetchData();

                  if (counter.length > 0) {
                    let newValue = parseInt(counter.text()) - ids.length;
                    counter.text(newValue);
                  }

                  if (xhr.status != 202) {
                    vm.fetchStories();
                  }
                },
              });

            }
          });
        } else {
          bootbox.alert('Selecione ao menos um item da lista...');
        }
      },

      showModalForSelectedItems(modalName) {
        if (this.selectedItems.length === 0) {
          return bootbox.alert('Selecione ao menos um item da lista...');
        }
        $(modalName).modal('show');
      },

      filterProducts(filter) {
        axios.get(this.fetch_url + '&filter_products=' + filter).then(resp => {
          this.updateDataListing(resp.data);
        });
      }
    },
  }
</script>
<style scoped>

    .active {
        font-weight: 700;
        background-color: #ecebeb;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/data-component/DataList.vue